declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    ElevarDataLayer?: Array<Record<string, unknown>>;
  }
}

let elevarUserDataFired = false;
let elevarCompleteQuizFired = false;

export function pushElevarUserData(): void {
  if (typeof window === 'undefined' || elevarUserDataFired) return;
  elevarUserDataFired = true;
  window.ElevarDataLayer = window.ElevarDataLayer ?? [];
  window.ElevarDataLayer.push({
    event: 'dl_user_data',
    user_properties: { visitor_type: 'guest' },
    ecommerce: {
      currencyCode: 'EUR',
      cart_contents: { products: [] },
    },
  });
}

export function pushElevarCompleteQuiz(variant: 'A' | 'B'): void {
  if (typeof window === 'undefined' || elevarCompleteQuizFired) return;
  pushElevarUserData();
  elevarCompleteQuizFired = true;
  window.ElevarDataLayer = window.ElevarDataLayer ?? [];
  window.ElevarDataLayer.push({
    event: 'dl_complete_quiz',
    event_properties: {
      quiz_result: variant === 'A' ? 'mainquiz_variant_a' : 'mainquiz_variant_b',
    },
  });
}

export const GTM_ID = 'GTM-PWCJ7JGV';

let initialized = false;

export function initGTM(): void {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}

export function pushDataLayer(event: string, params: Record<string, unknown> = {}): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

// Mapping van quiz screenId → GTM step_number + step_label
// Naamgeving volgt de officiële GTM-spec; step_number is chronologisch.
export const SCREEN_STEP_MAP: Record<string, { step_number: number; step_label: string }> = {
  scr1:           { step_number: 1,  step_label: 'age selection' },
  scrSafety:      { step_number: 2,  step_label: 'safety check' },
  scr2:           { step_number: 3,  step_label: 'improvement selection' },
  scr3:           { step_number: 4,  step_label: 'wrinkle depth' },
  scr4:           { step_number: 5,  step_label: 'what to improve' },
  scr5:           { step_number: 6,  step_label: 'rating showed' },
  scr6:           { step_number: 7,  step_label: 'sun exposure' },
  scr7:           { step_number: 8,  step_label: 'sleep' },
  scr8:           { step_number: 9,  step_label: 'stress' },
  scr9:           { step_number: 10, step_label: 'skin tone' },
  scr10:          { step_number: 11, step_label: 'skin sensitivity' },
  scr11:          { step_number: 12, step_label: 'calcutalion' },
  scr11b:         { step_number: 13, step_label: 'percentage showed' },
  scr12:          { step_number: 14, step_label: 'triedsolutions selection' },
  scr13:          { step_number: 15, step_label: 'this is why' },
  scr14:          { step_number: 16, step_label: 'want prof help' },
  scr15:          { step_number: 17, step_label: 'what is happening' },
  scr16:          { step_number: 18, step_label: 'feel older' },
  scr17:          { step_number: 19, step_label: 'how would it feel' },
  scr18:          { step_number: 20, step_label: 'upcoming event' },
  scr18b:         { step_number: 21, step_label: 'results loader' },
  scr19:          { step_number: 22, step_label: 'last page' },
  scrNotSuitable: { step_number: 99, step_label: 'not suitable' },
};

export function pushPageOpen(): void {
  pushDataLayer('page_open');
}

const firedFormSteps = new Set<number>();

export function pushFormProgress(screenId: string | undefined): void {
  if (!screenId) return;
  const mapped = SCREEN_STEP_MAP[screenId];
  if (!mapped) return;
  if (firedFormSteps.has(mapped.step_number)) return;
  firedFormSteps.add(mapped.step_number);
  pushDataLayer('form_progress', {
    step_number: mapped.step_number,
    step_label: mapped.step_label,
  });
}

export function pushClickToWebsite(): void {
  pushDataLayer('click_to_website');
}